export default __webpack_public_path__ + "static/media/33.3a63ff76.jpeg";